import { EBuildingCranageType } from 'shared/types/filters/advanced/buildingCranageTypesType';

export const mapBuildingCranageTypesTypeLabel = {
  [EBuildingCranageType.Overhead]: 'Мостовой кран',
  [EBuildingCranageType.Beam]: 'Кран-балка',
  [EBuildingCranageType.Railway]: 'Ж/д кран',
  [EBuildingCranageType.Goat]: 'Козловой кран',
};
